import {BookingActionsRepository} from "../../domain/types";
import {BookingActionsRepositoryV2} from "./repository.v2";

export {BookingActionsRepositoryV2} from "./repository.v2";
export type {BookingActionsRepository} from "../../domain/types";

/**
 * Creates the BookingActionsRepository.
 *
 * @example
 * const repository = createBookingActionsRepository();
 * await repository.cancelBooking({actor: "coach", reference, reason});
 */
export const createBookingActionsRepository = (): BookingActionsRepository => {
  return new BookingActionsRepositoryV2();
};
